import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TermsAndConditions.css";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-logo">Terms and Conditions</div>
        <button className="login-button" onClick={() => navigate("/login")}>
          Login
        </button>
      </nav>

      <div className="terms-container">
        <p className="meta">
          <strong>Effective Date:</strong> 23 July 2025
          <br />
          <strong>Last Updated:</strong> 23 July 2025
        </p>

        <section className="box">
          <p>
            PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING OUR WEBSITE. BY ACCESSING OR PARTICIPATING IN Op4Insights, YOU AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS, PLEASE DO NOT USE OUR SERVICES.
          </p>
          <p>
            Op4Insights is a market research panel operated by Op4Insights, providing opportunities for individuals to participate in surveys and other research-related activities in exchange for rewards.
          </p>
          <p>
            By registering and using the Op4Insights platform, you agree to comply with the following Terms and Conditions. We reserve the right to update these terms at any time without prior notice. Please review this page regularly to stay informed of any updates.
          </p>
        </section>

        <section className="box">
          <p>
            If you object to any of these terms or subsequent modifications, your sole remedy is to discontinue your use of Op4Insights and terminate your membership. Op4Insights reserves the right to modify or discontinue services at any time without notice.
          </p>
          <h2><strong>Eligibility and Registration</strong></h2>
          <ul>
            <li>You must be of legal age as per the laws of your country to register and participate in Op4Insights. One account per person is permitted.</li>
            <li>Participation is limited to residents of eligible countries. A complete list of eligible countries is maintained on our website and may be updated periodically.</li>
            <li>You agree to provide accurate, current, and complete information during registration and to update such information to keep it accurate.</li>
          </ul>
        </section>

        <section className="box">
          <h2><strong>Use of the Website and Membership</strong></h2>
          <ul>
            <li>By becoming a member, you agree to receive invitations to participate in online surveys and other research activities.</li>
            <li>Participation is voluntary and may earn you rewards or incentives as specified in each activity.</li>
            <li>Rewards may include points, gift cards, or sweepstakes entries, subject to the specific terms of the reward program.</li>
            <li>Members are responsible for maintaining the confidentiality of their account login information.</li>
            <li>Misuse of the platform, including multiple accounts, false information, or fraudulent activity, may result in termination of your account and forfeiture of any rewards.</li>
          </ul>
        </section>

        <section className="box">
          <h2><strong>Incentives and Taxes</strong></h2>
          <ul>
            <li>All taxes, fees, and surcharges on any rewards or prizes are the sole responsibility of the member.</li>
            <li>If a member is under the legal age in their country and wins a reward, it will be awarded to their parent or legal guardian upon verification.</li>
            <li>Employees of Op4Insights, its parent company, subsidiaries, affiliates, and their immediate family members are not eligible to participate or win any incentives.</li>
            <li>No purchase is necessary to participate in any survey or contest.</li>
          </ul>
        </section>

        <section className="box">
          <h2><strong>Privacy and Data Usage</strong></h2>
          <ul>
            <li>All personal information is collected, used, and stored in accordance with our <a href="/privacy">Privacy Policy</a>.</li>
            <li>Op4Insights complies with applicable data protection laws such as GDPR, CCPA, and other international standards.</li>
            <li>Your data will never be sold or used for marketing purposes without your consent.</li>
          </ul>
        </section>

        <section className="box">
          <h2><strong>Termination and Suspension</strong></h2>
          <ul>
            <li>Op4Insights may suspend or terminate your account at any time if there is a breach of these Terms or any suspected fraudulent or abusive behavior.</li>
            <li>You may cancel your account at any time by contacting our support team.</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
